import axiosClient from "./axiosClient";

const DEFAULT_CENTER_ID = "67b4559db586fd615075e72e";

class DrivingService {
    constructor() {
        this.axiosClient = axiosClient;
    }

    async lookupPaymentByIdentityCard(identityCardNumber, centerId = DEFAULT_CENTER_ID) {
        return this.axiosClient.get("/driving/payment/lookup/by-identity-card", {
            params: {
                identityCardNumber,
                centerId
            }
        });
    }

    async getElearningStatusByRegistrationCode(registrationCode, cardNumber, courseCode) {
        return this.axiosClient.get("/driving/elearning/status", {
            params: {
                registrationCode,
                // Fallback ghép CCCD + mã khoá CSDL khi HV có nhiều mã / mã DAT
                // khác mã elearning (BE tự dùng khi tra theo mã không thấy).
                ...(cardNumber ? { cardNumber } : {}),
                ...(courseCode ? { courseCode } : {}),
            }
        });
    }

    // Verify a short-lived JWT minted by uniapp-backend
    // /elearning/my/request-cabin-booking. Used when a student arrives
    // here via the LMS "Đăng ký lịch cabin" redirect — we only show
    // booking info for the student claim'd by the JWT, never look up
    // anyone else. Backend route is public (stateless verify) but the
    // JWT itself is signed with ELEARNING_SESSION_TOKEN_SECRET.
    async verifyCabinToken(token) {
        return this.axiosClient.get("/elearning/verify-cabin-token", {
            params: { token },
        });
    }

    async listInvoiceDrivingTeachers(page, limit, signal) {
        return this.axiosClient.get("/driving/teacher", {
            signal,
            params: {
                page,
                limit,
                department: "invoice",
                sortBy: "code",
                sortOrder: "asc"
            }
        });
    }

    async getDrivingCenterSetting() {
        return this.axiosClient.get(`/driving/setting/center/${DEFAULT_CENTER_ID}`);
    }
}

const DrivingServiceInstance = new DrivingService();
export default DrivingServiceInstance;
